<template>
  <div class="flex_column_horizontally_vertical_center about_user">
    <div class="flex_row_horizontally_vertical_center"  style="margin-top: 10px">
      <AboutUserView></AboutUserView>
    </div>
    <div class="flex_row_horizontally_vertical_center" style="margin-top: 160px">
      <AboutUserView></AboutUserView>
      <AboutUserView style="margin-left: 250px"></AboutUserView>
    </div>
    <div class="flex_row_horizontally_vertical_center" style="margin-top: 350px;">
      <AboutUserView></AboutUserView>
      <AboutUserView style="margin-left: 80px"></AboutUserView>
    </div>
  </div>
</template>

<script>
import AboutUserView from "@/components/AboutUserView.vue";

export default {
  name: "FiveAboutUser",
  components: {AboutUserView}
}
</script>

<style scoped>

.about_user {
  background-image: url("https://article-1326545904.cos.ap-beijing.myqcloud.com/05b966dd650f8d7d74d8c22da30f5ce12108121485e70-JvBmuS.png");
  background-size: contain;
  backgroundRepeat: no-repeat;
  width: 100%;
}
</style>